import type { Locale } from '@/lib/i18n/config'
import { localizePath } from '@/lib/i18n/config'

export const BOOKING_CANONICAL_PATH = '/booking'

export function getBookingPath(apartmentSlug?: string): string {
  const slug = apartmentSlug?.trim()
  if (!slug) return BOOKING_CANONICAL_PATH

  const searchParams = new URLSearchParams({ apartment: slug })
  return `${BOOKING_CANONICAL_PATH}?${searchParams.toString()}`
}

export function getBookingHref(locale: Locale, apartmentSlug?: string): string {
  return localizePath(getBookingPath(apartmentSlug), locale)
}
